// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ra8jL","outlineButton":"styles_outlineButton__gG8zG","mainImage":"styles_mainImage__6p8Zr"};